import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import "./welcome.sass";
import { BASE } from "../basedata/constants";

const Welcome = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage("pt");
  }, [i18n]);

  return (
    <div className="main-container">
      <div className="welcome-card maintenance-card">
        <h1 className="bepass-title">{t("maintenance_page.title")}</h1>
        <p className="bepass-text-default">{t("maintenance_page.description")}</p>
        <p className="bepass-text-default maintenance-subtext">
        <Trans i18nKey="maintenance_page.subtext"
            values={{ company_name: BASE.company.name}}
            />
          {/* {t("maintenance_page.subtext", { company_name: BASE.company.name })} */}
        </p>
      </div>
    </div>
  );
};

export default Welcome;
